var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVeerLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 25,
    viewBox: "0 0 121 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.9238 17.3448C71.8084 17.2971 77.1902 18.5862 73.0346 19.5989C69.7109 20.4088 66.7802 18.325 66.8819 15.5066C69.9252 15.5164 80.2076 15.8895 82.4139 15.2472C83.1934 0.035408 63.7232 -0.276627 61.1741 11.3868C57.8736 26.4876 79.542 28.8923 81.9238 17.3448Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.606 17.408C104.644 17.3331 101.231 17.2123 100.414 17.3777C98.9445 17.675 98.8584 18.9239 96.8772 19.5208C93.574 20.5161 90.4947 18.4969 90.4104 15.4901C93.3858 15.5632 103.745 15.8662 105.989 15.2752C106.991 0.234973 87.0188 -0.587842 84.6729 11.7508C82.1798 24.8628 100.608 30.245 105.606 17.408Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.2362 24.1832L51.7252 24.2011C51.7826 24.0718 51.8588 23.8382 51.882 23.8957L53.916 19.0132C55.099 15.993 59.7738 4.43075 59.8996 2.97056L53.9211 3.0071L49.1906 16.0099C47.1087 12.4164 45.9805 6.57515 44.0937 2.96432L37.9719 2.99552C39.6272 7.63823 45.5533 21.4041 46.2362 24.1832Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.293 24.2307L113.58 24.196C114.093 21.3839 113.584 16.5388 113.723 13.4624C113.936 8.72826 116.039 8.97878 120.519 8.95827L120.556 3.74814C118.2 3.78292 116.25 3.56449 114.292 4.84509L112.706 5.95448L111.632 3.8306L108.215 3.78693C107.889 5.97234 107.848 22.4915 108.293 24.2307Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.127 0.579576C8.24891 1.04668 7.14983 1.7514 6.68942 3.81379C6.25588 5.75759 7.12519 7.57796 8.56298 8.5073C10.1726 9.54764 19.0245 9.67019 21.4228 9.11617C25.5136 8.1712 25.7078 3.06584 22.7261 1.08415C20.8115 -0.188417 12.4888 -0.00789274 10.127 0.579576Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.6391 15.2466C6.37028 16.8713 6.56994 16.0623 7.20497 17.7828C9.87813 16.6672 14.8707 12.3267 21.9333 16.5687C22.3449 16.816 22.4977 16.9373 22.8751 17.1699C23.8347 17.761 22.9421 17.2979 23.9341 17.7828C24.8973 16.6859 25.3153 16.599 25.6203 15.2448C22.6317 13.6616 20.7385 11.9313 15.833 11.889C9.99027 11.8386 9.16427 13.6808 5.6391 15.2466Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6276 16.4136C24.8506 17.228 24.181 18.5772 25.0457 20.6779C25.6183 22.0695 27.088 23.5792 29.102 23.0389C32.7402 22.0628 29.6326 15.0363 26.6276 16.4136Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.869267 22.1238C4.64925 24.6017 7.60777 21.2952 6.44122 17.7611C5.5883 16.0838 3.70652 15.4584 2.34303 16.8856C1.32147 17.9554 0.499535 20.1662 0.869267 22.1238Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.8838 11.5159L76.7093 11.6113C75.7972 9.56989 74.7305 7.99113 71.7856 7.94388C68.9616 7.89842 67.7399 9.55251 66.8838 11.5159Z",
    fill: "#504A40"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.4731 11.4469L100.264 11.6296C98.8441 7.63858 94.8407 7.05248 92.2428 8.94414C90.9308 9.89979 91.1428 10.111 90.4731 11.4469Z",
    fill: "#504A40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeerLogoWhite);
export default __webpack_public_path__ + "static/media/veer-logo-white.dbd3f14d660d95f86c4dfbba2d35c87a.svg";
export { ForwardRef as ReactComponent };